export const startWithSlash = (input) => (input.startsWith('/') ? input : `/${input}`);
